import { Component, NgZone } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { AuthService } from '../../shared/services/auth.service';
import { ColDef } from 'ag-grid-community';
import { TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageService } from '../../shared/services/image.service';

@Component({
  selector: 'app-beneficiaries',
  standalone: false,
  templateUrl: './beneficiaries.component.html',
  styleUrl: './beneficiaries.component.scss'
})
export class BeneficiariesComponent {

  count = 0;
  @ViewChild('content') content!: TemplateRef<any>;
  selectedBeneficiary: any;
  dynamicFieldsList: { key: string, value: any }[] = [];
  rejectionReason: string = '';
  apiUrl: any;
  user: any;
  gridApi: any;
  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Action',
      field: 'action',
      width: 80,
      cellRenderer: (params: any) => {
        if (params.data?.isActive === false) {
          return document.createElement('div');
        }
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye-fill"></i>';
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.onView(params);
          });
        });
        return button;
      }
    },
    {
      headerName: 'Status',
      field: 'status',
      width: 80,
      editable: false,
      sortable: true,
      filter: true,
      cellClass: (params) => {
        return params.value === 'Approved'
          ? 'text-success'
          : params.value === 'Rejected'
            ? 'text-danger'
            : 'text-dark';
      },
      cellRenderer: (params: any) => {
        const status = params.data?.isActive === false ? 'Deleted' : params.value;
        const container = document.createElement('div');
        const statusSpan = document.createElement('span');
        statusSpan.className =
          `badge ${status === 'Approved'
            ? 'bg-success'
            : status === 'Rejected'
              ? 'bg-danger'
              : status === 'Deleted'
                ? 'bg-secondary'
                : 'bg-warning text-dark'
          }`;
        statusSpan.textContent = status;
        container.appendChild(statusSpan);
        return container;
      }
    },
    {
      headerName: 'Beneficiary Name',
      field: 'beneficiaryName',
      editable: false,
      filter: false,
      sortable: false,
    },
    {
      headerName: 'Account Number',
      field: 'accountNumber',
      editable: false,
      filter: false,
      sortable: false,
      valueGetter: (params) => {
        if (params.data?.isBill && params.data?.customerFields) {
          return Object.values(params.data.customerFields).join(', ');
        }
        return params.data?.accountNumber;
      }
    },
    {
      headerName: 'Bank Name',
      field: 'dynamicFields.Bank Name',
      editable: false,
      filter: false,
      sortable: false,
    },
    {
      headerName: 'Mobile No',
      field: 'mobileNumber',
      editable: false,
      filter: false,
      sortable: false,
    },
  ];

  constructor(private _api: ApiService,
    private zone: NgZone,
    private _auth: AuthService,
    private modalService: NgbModal,
    private _imageService: ImageService
  ) {
  }

  ngOnInit() {
    const vm = this;
    vm.user = vm._auth.getUser();
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    vm.gridApi.sizeColumnsToFit();
  }


  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        this.apiUrl = '/partners/auth/getBeneficiariesByPartnerId' + '?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + encodeURIComponent(filterData[k].filter);
          }
        });
        if (params.sortModel && params.sortModel.length > 0) {
          const sortFields = params.sortModel.map(s => s.colId).join(',');
          const sortOrders = params.sortModel.map(s => s.sort).join(',');
          vm.apiUrl = vm.apiUrl + '&_sort=' + encodeURIComponent(sortFields) + '&_order=' + encodeURIComponent(sortOrders);
        }
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  private processDynamicFields(data: any) {
    const excludeKeys = ['Confirm Account Number', 'Confirm Account NumberMasked', 'Transaction Type', 'Bank NameImageUrl', 'Bank Name'];
    const labelMap: Record<string, string> = {
      'Bank NameImageUrl': 'Bank Logo'
    };
    this.dynamicFieldsList = [];
    if (data?.dynamicFields) {
      Object.keys(data.dynamicFields).forEach(k => {
        const val = data.dynamicFields[k];
        if (!excludeKeys.includes(k) && val != null && val !== '') {
          this.dynamicFieldsList.push({ key: labelMap[k] || k, value: val });
        }
      });
    }
  }

  onView(params: any) {
    const vm = this;
    vm.selectedBeneficiary = params.data;
    vm.processDynamicFields(params.data);
    const receiverDOB = vm.selectedBeneficiary?.dynamicFields?.DOB;

    const receiverEpochDob = receiverDOB
      ? (() => {
        const [day, month, year] = receiverDOB.split('-');
        return new Date(Number(year), Number(month) - 1, Number(day)).getTime();
      })()
      : null;
    const receiverObj = {
      'name': vm.selectedBeneficiary.beneficiaryName,
      'nationality': vm.selectedBeneficiary.countryId.displayName,
      'dob': receiverEpochDob
    };
    vm.verifyWithTutelar(receiverObj, vm.selectedBeneficiary, 'receiverValidation');
    const senderObj = {
      'name': vm.selectedBeneficiary.senderName,
      'nationality': vm.selectedBeneficiary.senderCountryName,
      'dob': vm.selectedBeneficiary.senderDOB
    };
    vm.verifyWithTutelar(senderObj, vm.selectedBeneficiary, 'senderValidation');
    vm.modalService.open(vm.content, {
      size: 'xl',
      // fullscreen: true,
      centered: true,
      backdrop: 'static'
    });
  }

  verifyWithTutelar(data: any, parentData: any, key: any) {
    const vm = this;
    const requestData = {
      name: data.name,
      nationality: data.nationality,
      ucic: new Date().getTime(),
      dob: data.dob,
    };
    parentData[key] = null
    vm._api.postData('/common/scan-propspect-tutelar', requestData).subscribe((res: any) => {
      if (res && !res.error) {
        parentData[key] = res.data.data;
      }
    });
  }

  onApprove(selectedBeneficiary, modal: any) {
    const vm = this;
    const reqObj = {};
    reqObj['_id'] = selectedBeneficiary._id;
    reqObj['status'] = 'Approved';
    reqObj['approvedDate'] = Date.now();
    vm._api.postData('/partners/auth/updateBeneficiaryStatus', reqObj).subscribe((res: any) => {
      if (res && !res.error) {
        modal.close();
        vm.gridApi.refreshInfiniteCache();
      }
    });
  }

  onReject(selectedBeneficiary, modal: any) {
    const vm = this;
    const reqObj = {};
    reqObj['_id'] = selectedBeneficiary._id;
    reqObj['status'] = 'Rejected';
    reqObj['rejectionReason'] = vm.rejectionReason;
    vm._api.postData('/partners/auth/updateBeneficiaryStatus', reqObj).subscribe((res: any) => {
      if (res && !res.error) {
        modal.close();
        vm.rejectionReason = '';
        vm.gridApi.refreshInfiniteCache();
      }
    });
  }

  formatDob(epoch: number, format: string): string {
    if (!epoch) return '';
    const d = new Date(epoch);
    if (isNaN(d.getTime())) return '';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    switch (format) {
      case 'MM-DD-YYYY': return `${mm}-${dd}-${yyyy}`;
      case 'YYYY-MM-DD': return `${yyyy}-${mm}-${dd}`;
      default: return `${dd}-${mm}-${yyyy}`;
    }
  }

  getImage(id) {
    if (id && id.startsWith('http')) {
      id = new URL(id).pathname.split('/').pop();
    }
    const vm = this;
    vm._imageService.fetchAndViewDoc(id);
  }

}
